/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { ToolbarComponentCommonProps } from '..';
import { useAppSelector } from '../../../../reducers';
import { useSurveyGroups } from '../../../../utils/survey';

export const ExpandAllToggle = (props: ToolbarComponentCommonProps) => {
  const { toggleExpandAll, isExpanded } = props;

  const overviewMode = useAppSelector(state => state.surveySettings.overviewMode);
  const surveyState = useAppSelector(state => state.survey);
  const surveyData = surveyState.loaded ? surveyState.data : undefined;
  const surveyGroups = useSurveyGroups(overviewMode, surveyData);

  const flatView = surveyGroups.length === 1;

  if (flatView) {
    return null;
  }

  return (
    <div className='text-right'>
      <Button color='link' size='sm' onClick={() => toggleExpandAll()} className='expand-all-btn'>
        {isExpanded ? 'Collapse all packs' : 'Expand all packs'}
      </Button>
    </div>
  );
}
